import { render, staticRenderFns } from "./HomeFaceBook.vue?vue&type=template&id=f8fd63f8&"
import script from "./HomeFaceBook.vue?vue&type=script&lang=js&"
export * from "./HomeFaceBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports